import { css } from 'lit';

export const styles = css`:host{--track-height: var(--ig-linear-progress-track-height, 0.125rem);--ig-theme: fluent}`;
